import React from 'react'
import PropTypes from 'prop-types'
import { graphql, useStaticQuery } from 'gatsby'

import Img from 'gatsby-image'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  grid: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '150px',
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '110px',
    },
  },
}))

const logos = [
  {
    xs: 4,
    sm: 3,
    md: 2,
    idName: 'DeutscheBahn',
    style: {},
  },
  {
    xs: 4,
    sm: 3,
    md: 2,
    idName: 'APS-Logo-blau',
    style: { margin: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 2,
    idName: '1600px-Flixtrain_Logo',
    style: {},
  },
  {
    xs: 4,
    sm: 3,
    md: 2,
    idName: 'Logo_BSN',
    style: { margin: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 2,
    idName: 'GDL',
    style: { marginLeft: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 3,
    idName: 'Fahrgastverband-PRO-BAHN',
    style: { marginRight: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 3,
    idName: 'VCD',
    style: { margin: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 3,
    idName: 'EVG',
    style: { margin: 'auto' },
  },

  {
    xs: 4,
    sm: 3,
    md: 3,
    idName: 'DieGueterbahnen-Logo',
    style: { marginLeft: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 2,
    idName: 'Alstom.svg',
    style: { marginRight: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 2,
    idName: 'Bombardier_Logo',
    style: { margin: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 2,
    idName: 'siemens-logo-default',
    style: { margin: 'auto' },
  },
  {
    xs: 3,
    sm: 3,
    md: 2,
    idName: 'bgl_logo',
    style: { margin: 'auto' },
  },
  {
    xs: 3,
    sm: 3,
    md: 2,
    idName: '2560px-BDI.svg',
    style: { margin: 'auto' },
  },
  {
    xs: 3,
    sm: 3,
    md: 2,
    idName: 'bvmb',
    style: { marginLeft: 'auto' },
  },

  {
    xs: 3,
    sm: 3,
    md: 3,
    idName: 'dslv-logo',
    style: { marginRight: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 3,
    idName: 'Logo-Bauindustrie-weiss',
    style: { margin: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 3,
    idName: 'logo-mofair',
    style: { margin: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 3,
    idName: '1280px-Verband_der_Bahnindustrie_logo.svg',
    style: { marginLeft: 'auto' },
  },

  {
    xs: 3,
    sm: 3,
    md: 1,
    idName: 'VDV',
    style: { margin: 'auto' },
  },
  {
    xs: 3,
    sm: 3,
    md: 1,
    idName: 'zdb-logo',
    style: { margin: 'auto' },
  },
  {
    xs: 3,
    sm: 3,
    md: 1,
    idName: 'VPI',
    style: { margin: 'auto' },
  },
  {
    xs: 3,
    sm: 3,
    md: 1,
    idName: 'ZVEI-Logo',
    style: { margin: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 1,
    idName: 'dvf_logo_01',
    style: { margin: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 1,
    idName: '2000px-IG_Metall_logo.svg',
    style: { margin: 'auto' },
  },
  {
    xs: 4,
    sm: 3,
    md: 1,
    idName: 'Deutscher-Bahnkunden-Verband',
    style: { marginLeft: 'auto' },
  },
]

const logosMap = logos.map((item) => item)

function LogoGrid() {
  const classes = useStyles()

  const { footerLogos } = useStaticQuery(graphql`
    query {
      footerLogos: allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativeDirectory: { eq: "footer/logos" }
        }
      ) {
        nodes {
          name
          childImageSharp {
            fluid(maxWidth: 250, quality: 80) {
              aspectRatio
              src
              srcSet
              sizes
            }
          }
        }
      }
    }
  `)

  return (
    <Grid
      container
      spacing={2}
      direction="row"
      justify="space-between"
      alignItems="center"
      role="group"
      aria-label="Logos"
    >
      {logosMap.map((item) => (
        <Grid
          item
          xs={item.xs}
          sm={item.sm}
          md={item.md}
          key={item.idName}
          className={classes.grid}
          role="listitem"
        >
          <Img
            style={{ ...item.style, width: '100%', maxWidth: '100%' }}
            imgStyle={{ height: 'auto' }}
            alt={`Logo - ${item.idName}`}
            fluid={{
              ...footerLogos.nodes?.find((node) => node.name === item.idName)
                ?.childImageSharp?.fluid,
              media: `(min-width: 0px)`,
            }}
            backgroundColor="grey"
          />
        </Grid>
      ))}
    </Grid>
  )
}

LogoGrid.propTypes = {
  className: PropTypes.string,
  level: PropTypes.number,
  id: PropTypes.string,
  children: PropTypes.any,
  html: PropTypes.string,
}

export default LogoGrid
